import React, { useState } from 'react';
import { Video, FileAudio, RotateCcw, Loader2 } from 'lucide-react';
import { useAudioEngine } from '../hooks/useAudioEngine';
import { logMyEvent } from '../firebase';

const VideoToAudio = ({ setIsExporting, setExportProgress }) => {
  const [videoFile, setVideoFile] = useState(null);
  const [vaStep, setVaStep] = useState(1);
  const { extractAudioFromVideo } = useAudioEngine(null, null);

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setVideoFile(file);
      setVaStep(2);
    }
  };

  const handleProcess = async (format) => {
    logMyEvent('extract_audio_start', { format });
    await extractAudioFromVideo(videoFile, format, setIsExporting, setExportProgress);
  };

  return (
    <div className="max-w-lg mx-auto text-center space-y-12 animate-in fade-in">
      {vaStep === 1 ? (
        <>
          <h2 className="text-4xl font-black uppercase tracking-tighter">Extract Audio From Video</h2>
          <p className="text-slate-400 leading-relaxed">Extract high-quality MP3 or WAV from your videos.</p>
          <div className="p-20 border-2 border-dashed border-slate-800 bg-slate-900/30 rounded-[40px] hover:border-amber-500 transition-colors cursor-pointer relative group">
            <Video className="mx-auto mb-6 text-amber-500/20 group-hover:text-amber-500 transition-colors" size={64} />
            <input type="file" className="absolute inset-0 opacity-0 cursor-pointer" accept="video/*" onChange={handleUpload} />
            <p className="font-bold text-amber-500 uppercase tracking-widest">Select Video File</p>
          </div>
        </>
      ) : (
        <div className="space-y-8">
          <div className="w-20 h-20 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto border border-amber-500/20">
            <FileAudio className="text-amber-500" size={32} />
          </div>
          <h3 className="text-2xl font-black uppercase truncate px-4">{videoFile?.name}</h3>
          <div className="grid grid-cols-2 gap-4">
            <button onClick={() => handleProcess('mp3')} className="p-8 bg-slate-900 border border-slate-800 rounded-3xl hover:border-amber-500 transition-all group">
              <span className="block text-2xl font-black">MP3</span>
              <span className="text-[10px] text-slate-500 uppercase font-black mt-2 block">Social Media Ready</span>
            </button>
            <button onClick={() => handleProcess('wav')} className="p-8 bg-slate-900 border border-slate-800 rounded-3xl hover:border-amber-500 transition-all group">
              <span className="block text-2xl font-black">WAV</span>
              <span className="text-[10px] text-slate-500 uppercase font-black mt-2 block">High Fidelity</span>
            </button>
          </div>
          <button onClick={() => setVaStep(1)} className="flex items-center gap-2 mx-auto text-slate-500 uppercase text-xs font-black hover:text-white transition-colors">
            <RotateCcw size={14} /> Back to Upload
          </button>
        </div>
      )}
    </div>
  );
};

export default VideoToAudio;